package app.smartcoding.realrate.platform

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth

actual suspend fun firebaseSignOut() {
    Firebase.auth.signOut()

}